<template>
  <div class="timesheet-outr">
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="sidebarx sidesheet arrows-change"
      spacer
      v-model="sidebar_active"
      v-if="sidebarUserData"
    >
      <div class="header-sidebar" slot="header">
        <vs-button
          class="float-left"
          color="#EA5455"
          type="border"
          icon-pack="feather"
          icon="icon-x"
          @click="CloseSlidebar()"
          v-bind:style="{ left: '170px'}"
        ></vs-button>
        <!--  <vs-avatar  size="70px" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)"/>-->
        <vs-avatar
          class="m-0"
          :src="sidebarUserData.profile_image"
          size="50px"
          v-if="sidebarUserData.profile_image"
        />
        <vs-avatar
          color="primary"
          class="m-0 name-avatar"
          :text="usernameList(sidebarUserData.firstname,sidebarUserData.lastname)"
          size="50px"
          v-else
        />

        <h4>
          {{ sidebarUserData.user_name }}
          <!-- <vs-button color="primary" icon="more_horiz" type="flat"></vs-button> -->
        </h4>
        <div v-if="sidebarUserData.users_in_out">
          <h6 class="mt-1">
            <b>Status :-</b>
            <span v-if="sidebarUserData.users_in_out.status == 'IN'">IN</span>
            <span v-if="sidebarUserData.users_in_out.status == 'OUT'">OUT</span>
            <span v-if="sidebarUserData.users_in_out.status == 'BI'">Break</span>
            <span
              v-if="sidebarUserData.users_in_out.comment"
            >({{sidebarUserData.users_in_out.comment}})</span>
          </h6>
          <h6 class="mt-1">
            <b>Last Updated Date :-</b>
           {{sidebarUserData.users_in_out.start_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}
          </h6>
          <h6 class="mt-1">
            <b>Last Updated Time :-</b>
              {{sidebarUserData.users_in_out.start_time | moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }}
          </h6>
          <h6 class="mt-1">
            <b>TimeZone :-</b>
            {{sidebarUserData.timeZone}}
          </h6>
        </div>
      </div>
      <div class="w-full" v-if="!addTimesheet && !editTimesheet && !deleteTimesheet">
        <h5 class="float-left ml-4 mt-3">
          <b>
            Viewing Timesheet For
            {{addTimeDate | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY')}}
          </b>
        </h5>
        <vs-button
          class="float-right mb-5"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          title="Add Time"
          v-if="!addTimesheet && !editTimesheet && !deleteTimesheet"
          @click="openAddForm()"
          v-bind:style="{ right: '20px',}"
        ></vs-button>
      </div>


    <!-- Static code -->

      <form class="mt-12" data-vv-scope="addtimesheet-form" v-if="addTimesheet">
      <!-- Date -->
        <div class="vx-row w-full ml-0 mb-2 align-items-center">
          <div class="vx-col md:w-1/1 form-group w-full">
            <h3 class="w-full text-center p-2">Add Timesheet</h3>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2 mb-2">
            <label for class="vs-input--label">Date</label>
            <datepicker
              placeholder="Select Date" :calendar-button="true" calendar-button-icon="fa fa-calendar"
              class="w-full calendar-icon-right top-45"
              :disabled="true"
              format="dd/MM/yyyy"
              v-model="addTimeDate"
            ></datepicker>
            <span></span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <span><b>Status</b></span>
          </div>
        </div>
        <!-- TIme1 -->
        <div class="vx-row w-full ml-0 mb-2 align-items-center">
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <label for class="vs-input--label">Time</label>
            <input
              class="vs-inputx vs-input--input normal time-input"
              type="time"
              name="clockInTime"
              v-model="clockInTime"
            />
            <span
              v-show="errors.has('addtimesheet-form.clockInTime')"
              class="text-danger text-sm block"
            >{{ errors.first('addtimesheet-form.clockInTime') }}</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <span>Clock In</span>
          </div>
        </div>
        <!-- TIme2 -->
        <div class="vx-row w-full ml-0 mb-2 align-items-center">
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <label for class="vs-input--label">Time</label>
            <input
              class="vs-inputx vs-input--input normal time-input"
              type="time"
              name="clockOutTime"
              v-model="clockOutTime"
            />
            <span
              v-show="errors.has('addtimesheet-form.clockOutTime')"
              class="text-danger text-sm block"
            >{{ errors.first('addtimesheet-form.clockOutTime') }}</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <span>Clock Out</span>
          </div>
        </div>

        <!-- Break 1 -->
        <div class="vx-row w-full ml-0 mb-2 align-items-center" v-for="(breakstartend,index) in breaksArray" :key="index">
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <label for class="vs-input--label">Break</label>
              <input
              class="vs-inputx vs-input--input normal time-input"
              type="time"
              name="clockOutTime"
              v-model="breakstartend.breakStartTime"
            />
            <span class="text-danger text-sm block" v-if="errCondition && errIndex ==index && errType =='start'">Please enter Break Start</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <span>Break Start</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <label for class="vs-input--label">Break</label>
             <input
              class="vs-inputx vs-input--input normal time-input"
              type="time"
              name="clockOutTime"
              v-model="breakstartend.breakEndTime"
            />

            <span class="text-danger text-sm block" v-if="errCondition && errIndex ==index && errType =='end'">Please enter Break End</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
            <div class="dis-flex">
              <span>Break End</span>
                <vs-button
                  v-if="breaksArray.length >1"
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  class="ml-2 common-button"
                  @click="removeBreak(index)"
                ></vs-button>
            </div>
          </div>
        </div>
        <!-- + Break -->
        <div class="vx-row w-full ml-0 mb-2 align-items-center">
          <div class="vx-col md:w-1/1 form-group w-full">
          <div class="dis-flex">
              <vs-button
              @click="addBreak()"
                color="null"
                type="flat"
                icon-pack="feather"
                title="Break"
                class="ml-1 vs-button-trans common-button"
                icon="icon-plus"
              >Break</vs-button>
            </div>
          </div>
        </div>

        <!-- Comment -->

        <div class="vx-row w-full ml-0 mb-2 align-items-center">
          <div class="vx-col md:w-1/1 form-group w-full">
            <label class="vs-input--label" for>Comment</label>
            <vs-input
              class="w-full"
              v-validate="'max:50'"
              name="comment"
              v-model="comment"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('addtimesheet-form.comment') }}</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-full">
            <vs-button
              class="mt-6 mr-5 gradient-btn shadow-lg m-auto remove-contact-person"
              @click.prevent="addMultipleTime()"
              size="medium"
            >Save</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddForm()">Cancel</vs-button>
          </div>
        </div>
      </form>

      <!-- Dynamic code -->

      <!-- <form
        data-vv-scope="addtimesheet-form"
        class="vx-row mb-2 w-full ml-0 mt-12"
        v-if="addTimesheet"
      >
        <h3 class="w-full text-center p-2">Add Timesheet</h3>
        <div class="vx-col md:w-1/1 form-group w-full mb-2">
          <label for class="vs-input--label">Date</label>
          <datepicker
            placeholder="Select Date" :calendar-button="true" calendar-button-icon="fa fa-calendar"
            class="w-full calendar-icon-right top-45"
            :disabled="true"
            format="dd/MM/yyyy"
            v-model="addTimeDate"
            :value="sidebarUserData.users_in_out.start_time"
          ></datepicker>
        </div>
        <div class="vx-col md:w-1/1 form-group w-1/2">
          <label for class="vs-input--label">Time</label>
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            name="clockInTime"
            v-model="clockInTime"
          />
          
          <span
            v-show="errors.has('addtimesheet-form.clockOutTime')"
            class="text-danger text-sm block"
          >{{ errors.first('addtimesheet-form.clockInTime') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-1/2">
          <span>Clock In</span>
        </div>
          <div class="vx-col md:w-1/1 form-group w-1/2">
          <label for class="vs-input--label">Time</label>
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            name="clockOutTime"
            v-model="clockOutTime"
          />
          
          <span
            v-show="errors.has('addtimesheet-form.clockOutTime')"
            class="text-danger text-sm block"
          >{{ errors.first('addtimesheet-form.clockOutTime') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-1/2"><span>Clock Out</span></div>
        <div v-for="(breakstartend,index) in breaksArray" :key="index" class="vx-row">
         <div class="vx-col md:w-1/1 form-group w-1/3">
          <label for class="vs-input--label">Break</label>
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            v-model="breakstartend.breakStartTime"
          />
          <span
            v-show="errors.has('addtimesheet-form.time')"
            class="text-danger text-sm block"
          >{{ errors.first('addtimesheet-form.time') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-1/1"><span>Break Start</span></div>
          <div class="vx-col md:w-1/1 form-group w-1/3">
          <label for class="vs-input--label">Break</label>
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            v-model="breakstartend.breakEndTime"
          />
          <span
            v-show="errors.has('addtimesheet-form.time')"
            class="text-danger text-sm block"
          >{{ errors.first('addtimesheet-form.time') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-1/4"><span>Break End</span> <vs-button v-if="breaksArray.length > 1" color="danger" type="filled" icon-pack="feather" icon="icon-minus" class="ml-2" @click="removeBreak(index)"></vs-button></div>
        </div> -->
        <!-- <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label">Status</label>
          <ul class>
            <li class="m-2 inline-flex">
              <vs-radio name="status" v-model="addStatus" v-validate="'required'" :vs-value="'CIN'">
                Clock
                ON
              </vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'COUT'"
              >
                Clock
                OFF
              </vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'BI'"
              >Break Start</vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'BS'"
              >Break End</vs-radio>
            </li>
          </ul>
          <span class="text-danger text-sm">{{ errors.first('addtimesheet-form.status') }}</span>
        </div> -->
        <!-- <div class="vx-col md:w-1/1 form-group w-full" @click="addBreak()">
          Break + 
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label" for>Note</label>
          <vs-input
            class="w-full"
            v-validate="'max:50'"
            name="comment"
            v-model="comment"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('addtimesheet-form.comment') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <vs-button
            class="mt-6 mr-5 gradient-btn shadow-lg m-auto remove-contact-person"
            @click.prevent="addMultipleTime()"
            size="medium"
          >Add</vs-button>
          <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddForm()">Cancel</vs-button>
        </div>
      </form> -->
      <form
        data-vv-scope="edittimesheet-form"
        class="vx-row mb-2 w-full ml-0 mt-12"
        v-if="editTimesheet"
      >
        <h3 class="w-full text-center p-2">Edit Timesheet</h3>
        <div class="vx-col md:w-1/1 form-group w-full mb-2">
          <label class="vs-input--label" for>Date</label>
          <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
            placeholder="Select Date"
            :disabled="true"
            class="w-full calendar-icon-right top-45"
            format="dd/MM/yyyy"
            v-model="editTimeDate"
          ></datepicker>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label" for>Time</label>

          <!-- <flat-pickr class="vs-inputx vs-input--input normal time" :config="configdateTimePicker" v-model="editTime" v-validate="'required'"  name="editTime" placeholder="Choose in time" /> -->
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            name="usr_time"
            v-model="editTime"
          />
        </div>
        <div class="vx-col md:w-1/1 form-group w-full mt-2">
          <label class="vs-input--label" for>Note</label>
          <vs-input
            class="w-full"
            v-validate="'max:50'"
            name="comment"
            v-model="comment"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('edittimesheet-form.comment') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <vs-button
            class="mt-6 mr-5 shadow-lg m-auto remove-contact-person gradient-btn"
            @click.prevent="editTimeData()"
            size="medium"
          >Save</vs-button>
          <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelEditForm()">Cancel</vs-button>
        </div>
      </form>
      <div
        class="vx-col md:w-1/1 form-group w-full delete-timesheet text-center mt-12"
        v-if="deleteTimesheet"
      >
        <div class="w-full">
          <h5>Are you sure you want to delete the timesheet?</h5>
        </div>
        <div class="w-full">
          <vs-button
            class="mt-6 shadow-lg m-auto remove-contact-person"
            color="danger"
            @click.prevent="deleteTimeSheet()"
            size="small"
          >Delete</vs-button>
          <vs-button
            class="ml-4 m-auto gradient-btn"
            size="small"
            @click.prevent="cancleDelete()"
          >Cancel</vs-button>
        </div>
      </div>
      <!-- <p>{{sidebarUserData.users_data}}</p> -->
      <vs-table
        :data="sidebarUserData.users_data"
        :disabled="true"
        v-if="!addTimesheet && !editTimesheet && !deleteTimesheet"
      >
        <template slot="thead">
          <vs-th>Status</vs-th>
          <vs-th style="width: 100px;">Time</vs-th>
          <vs-th>Updated By</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            v-if="checkTimesheetDate(tr.start_time,addTimeDate,sidebarUserData.timeZone) && checkStatus(tr.main_status,tr.status,tr.is_clockedIn)"
          >
            <vs-td>{{ manageStatus(tr.main_status,tr.status,tr.is_clockedIn) }} </vs-td>
            <vs-td>
              <!-- {{tr.start_time |  moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }} -->
              {{tr.start_time | moment('timezone',sidebarUserData.timeZone, 'hh:mm a') }}
            </vs-td>
            <vs-td>{{tr.updated_by ? tr.updated_by : '--' }}</vs-td>
            <vs-td>
              <vs-button
                class="float-left"
                color="primary"
                type="flat"
                icon-pack="feather"
                title="Edit Time"
                icon="icon-edit-2"
                @click="editTimeForm(tr)"
              ></vs-button>
              <vs-button
                color="danger"
                type="flat"
                icon-pack="feather"
                title="Delete Time"
                icon="icon-trash-2"
                @click="confirmDelete(tr._id)"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-sidebar>
  </div>
</template>

<script>
import { EventBus } from '@/mixins/mixin.js';
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "fullcalendar/dist/fullcalendar.css";
export default {
  components: {
    Datepicker,
    flatPickr,
    jsPDF,
    vSelect,
    "vue-json-to-csv": VueJsonToCsv
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      deleteIndex: 0,
      addTimesheet: false,
      editTimesheet: false,
      deleteTimesheet: false,
      editTime: null,
      editTimeID: null,
      addStatus: null,
      addTime: null,
      comment: null,
      InOutStatus: [
        {
          value: "IN",
          name: "In"
        },
        {
          value: "OUT",
          name: "Out"
        },
        {
          value: "CIN",
          name: "Clock In"
        },
        {
          value: "COUT",
          name: "Clock Out"
        },
        {
          value: "BI",
          name: "Break Start"
        },
        {
          value: "BS",
          name: "Break End"
        }
      ],
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: false
      },
      sidebar_active: false,
      activeUserTable: false,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      perPage1: 25,
      totalPage1: 1,
      currentPage1: 1,
      status: "A",
      switch1: true,
      MonthlyTimeSheet: [],
      WeeklyTimeSheet: [],
      DailyTimeSheet: [],
      searchresult: [],
      weeklySearchresult: [],
      monthlySearchresult: [],
      MonthDates: [],
      WeekDates: [],
      userID: null,
      addTimeDate: null,
      editTimeDate: null,
      currentDate: new Date(),
      currentMonth: new Date(),
      date: new Date(),
      recordList: [
        {
          text: 25,
          value: 25
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 100,
          value: 100
        },
        {
          text: 250,
          value: 250
        }
      ],
      config: {
        defaultView: "month",
        eventClick: event => {
          this.selected = event;
          this.openUserTimesheetDetail(this.MonthlyTimeSheet[0].user_id, event.date);
        }
      },
      selected: {},
      format: "dd/MM/yyyy",
      sidebarUserData: null,
      userActivityData: null,
      userDayActivityData: null,
      currentTime: null,
      totalActiveMinutesOfMonth: null,
      totalActiveMinutesOfWeek: null,
      csvData: [],
      csvWeekData: [],
      csvMonthData: [],
      collapseFlag: false,
      daysWorked: null,
      flag: false,
      responseOfProgressBar: [],
      departments: [],
      departmentsAll: [],
      isUserTimeSheet:false,
      department_id: [{ department_name: "All Departments", id: "all" }],
      breaksArray:[{
        breakStartTime:null,
        breakEndTime:null,
      }],
      errCondition:false,
      errIndex:-1,
      errType:null,
      clockInTime:'',
      clockOutTime:'',
    };
  },
  mounted: function() {
    EventBus.$on('open_timesheet_sidebar', (data) => {
      if (data.id && data.current_date) {
        this.isUserTimeSheet = data.isUserTimeSheet;
        this.openUserTimesheetDetail(data.id,data.current_date);
      }
    });
  },
  watch: {
  },
  computed: {
  },
  methods: {
    removeBreak(i){
      this.breaksArray.splice(i, 1);
          this.errCondition = false;
          this.errIndex = -1;
          this.errType = null;
    },
    addBreak(){
      let err = false;
      this.breaksArray.forEach((element,index) => {
        if(!element.breakStartTime || !element.breakEndTime){
            this.errCondition = true;
            this.errIndex = index;
            this.errType = !element.breakStartTime?'start':'end';
            err = true;
            return false;
        } 
      });
       if(!err){
           this.errCondition = false;
          this.errIndex = -1;
          this.errType = null;
          err = false;
          this.breaksArray.push({
            breakStartTime:null,
            breakEndTime:null
          });
        }
    },
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
      /*  return firstname.trim() + " " + lastname.trim(); */
    },
    checkTimesheetDate(startDate, currentDate, timezone) {
      if (startDate) {
        let current = moment.tz(currentDate, timezone).format('DD/MM/YYYY')
        let start_date = moment.tz(startDate, timezone).format('DD/MM/YYYY')
        if (current == start_date) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    openAddForm() {
      this.addTimesheet = true;
    },
    cancelAddForm() {
      this.addTime = null;
      this.addStatus = null;
      this.comment = null;
      this.addTimesheet = false;
      this.editTimesheet = false;
      this.deleteTimesheet = false;
      this.clockInTime = null;
      this.clockOutTime = null;
      this.breaksArray = [{
           "breakStartTime" : null,
          "breakEndTime" : null 
      }];
      this.errCondition = false;
      this.errIndex = -1;
      this.errType = null;
    },
    editTimeForm(tr) {
      this.addTimesheet = false;
      this.deleteTimesheet = false;
      this.editTimesheet = true;
      this.editTime = moment.tz(tr.start_time, this.timezone).format('HH:mm');
      this.editTimeID = tr._id;
    },
    addMultipleTime(){
      this.$validator.validateAll("addtimesheet-form").then(result => {
        if(this.breaksArray.length>1){
          this.breaksArray.forEach((element,index) => {
          if(!element.breakStartTime){
            this.errCondition = true;
            this.errIndex = index;
            this.errType = !element.breakStartTime?'start':'end';
            return false;
          } else {
            this.errCondition = false;
            this.errIndex = -1;
            this.errType = null;
          }
        });
        }
       
        if(result && !this.errCondition){
         let today = moment(this.addTimeDate).format("YYYY-MM-DD");
          this.breaksArray.forEach(element => {
            element.breakStartTime = element.breakStartTime?moment.tz(today+" "+element.breakStartTime,this.timezone).valueOf():0;
            element.breakEndTime = element.breakEndTime?moment.tz(today+" "+element.breakEndTime,this.timezone).valueOf():0;
          });
          let input = {
            user_id: this.userID,
            clockInTime:this.clockInTime?moment.tz(today+" "+this.clockInTime,this.timezone).valueOf():0,
            clockOutTime:this.clockOutTime?moment.tz(today+" "+this.clockOutTime,this.timezone).valueOf():0,
            breaksArray:this.breaksArray,
            comment: this.comment
          };
             this.$vs.loading({
            color: "primary"
          });

          this.axios
            .post("timesheet/addMutiple", input)
            .then(response => {
              this.$vs.loading.close();

              let data = response.data.data;
              let uDate = this.addTimeDate;
              this.CloseSlidebar();
              //let uDate  = moment.tz(data.data.start_time, this.timezone).valueOf();
              // let uDate = moment(data.data.start_time)
              //   .zone(this.timezone)
              //   .valueOf();
              let uID = this.userID;

              var text = "Timesheet has been added successfully!!!";

              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
             // this.openUserTimesheetDetail(uID, uDate);
              this.cancelAddForm();
            })
            .catch(e => {
              this.showError(e);
            });
        
        }
      });
    },
    addTimeData() {
      this.$validator.validateAll("addtimesheet-form").then(result => {
        if (result) {
          let input = {
            from_time: this.addTime,
            user_id: this.userID,
            date: moment(this.addTimeDate).format("DD/MM/YYYY"),
            status: this.addStatus,
            comment: this.comment
          };
          this.$vs.loading({
            color: "primary"
          });

          this.axios
            .put("inout/addTimeSheet", input)
            .then(response => {
              this.$vs.loading.close();

              let data = response.data.data;
              let uDate  = moment.tz(data.data.start_time, this.timezone).valueOf();
              // let uDate = moment(data.data.start_time)
              //   .zone(this.timezone)
              //   .valueOf();
              let uID = data.data.user_id;

              var text = "Timesheet has been added successfully!!!";

              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              this.cancelAddForm();
              this.openUserTimesheetDetail(uID, uDate);
            })
            .catch(e => {
              this.showError(e);
            });
        }
      });
    },
    editTimeData() {
      let input = {
        id: this.editTimeID,
        date: moment(this.editTimeDate).format("DD/MM/YYYY"),
        time: this.editTime,
        comment: this.comment
      };
      this.$vs.loading({
        color: "primary"
      });

      this.axios
        .put("inout/editTimeSheet", input)
        .then(response => {
          this.$vs.loading.close();

          let data = response.data.data;
          let uDate  = moment.tz(data.data.start_time, this.timezone).valueOf();
          // let uDate = moment(data.data.start_time)
          //   .zone(this.timezone)
          //   .valueOf();
          let uID = data.data.user_id;

          var text = "Timesheet has been updated successfully!!!";

          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.editTimesheet = null;
          this.editTime = null;
          this.editTimeID = null;
          this.editTimeDate = null;
          this.CloseSlidebar();
          //this.openUserTimesheetDetail(uID, uDate);
        })
        .catch(e => {
          this.showError(e);
        });
    },
    cancelEditForm() {
      this.editTimesheet = false;
      this.editTime = null;
      this.editTimeID = null;
    },
    CloseSlidebar() {
      this.sidebar_active = false;
      EventBus.$emit('reload_details');
    },
    CloseActivityTable() {
      this.activeUserTable = false;
    },
    async openUserTimesheetDetail(userID, userDate) {
      let current_date = moment.tz(this.currentDate, this.timezone).format('DD/MM/YYYY');
      let user_date = moment.tz(userDate, this.timezone).format('DD/MM/YYYY');
      if (current_date < user_date) {
        return;
      }

      this.$vs.loading({
        color: "primary"
      });

     

      let url = "inout/getDailyTimeSheet?records=records";
      url += "&date=" + user_date;
      url += "&user_id=" + userID;

      return await this.axios
          .get(url)
          .then(response => {
            this.$vs.loading.close();
            let data = response.data.data;
            if (data.data.length != 0) {
              this.sidebarUserData = data.data[0];
              this.sidebarUserData.timeZone = data.timeZone;
              this.userID = userID;
              this.addTimeDate = userDate;
              this.editTimeDate = userDate;
              this.sidebar_active = true;
              this.cancelAddForm();
            } else {
              let error = "Records not found";
              this.$vs.notify({
                text: error,
                color: "danger",
                position: "top-right"
              });
              this.sidebarUserData = [];
            }
            return true;
          })
          .catch(e => {
            this.showError(e);
            return false;
          });
      // this.sidebar_active = true;
    },
    confirmDelete(index) {
      this.addTimesheet = false;
      this.editTimesheet = false;
      this.deleteTimesheet = false;
      setTimeout(() => {
        this.deleteIndex = index;
        this.deleteTimesheet = true;
      }, 100);
    },
    cancleDelete() {
      this.deleteIndex = 0;
      this.deleteTimesheet = false;
    },
    deleteTimeSheet() {
      let input = {
        // data: {
        id: this.deleteIndex
        // }
      };
      this.$vs.loading({
        color: "primary"
      });
      this.axios
        .put("inout/deleteTimeSheet", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Timesheet has been deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.deleteTimesheet = false;

          let data = response.data.data;
          let uDate  = moment.tz(data.data.start_time, this.timezone).valueOf();
          // let uDate = moment(data.data.start_time)
          //   .zone(this.timezone)
          //   .valueOf();
          let uID = data.data.user_id;
          this.openUserTimesheetDetail(uID, uDate);
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
      this.$vs.loading.close();
    },
    // Manage status
    manageStatus(main_status,status,is_clockedIn){
      let text = '-';
      if (main_status == 'CIN' && status == 'IN' && !is_clockedIn) {
        text = 'In';
      } 
      else if (main_status == 'CIN' && status == 'IN' && is_clockedIn) {
        text = 'Clock On';
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Out';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break Start';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'Break End';
      }
      else if (main_status == 'CIN' && status == 'OUT') {
        text = 'Out';
      }
      return text;
    },
    checkStatus(main_status,status,isClockedIn){
      if(this.isUserTimeSheet){
        if (main_status == 'CIN' && status == 'IN' && isClockedIn) {
          return true;
        } 
        else if (main_status == 'COUT' && status == 'OUT') {
          return true;
        }
        else if (main_status == 'CIN' && status == 'BI') {
          return true;
        } 
        else if (main_status == 'CIN' && status == 'BS') {
          return true;
        }
        else if (main_status == 'CIN' && status == 'OUT') {
          return false;
        }
        else {
          return false;
        }
      } else {
         return true;
      }
    },
  }
};
</script>

<style>
.fc-today-button,
.fc-month-button,
.fc-agendaWeek-button,
.fc-agendaDay-button {
  display: none !important;
}
.application-action {
  float: left !important;
}

.time-box {
  background-color: lightgrey;
  width: 100px;
  border: 1px black;
  padding: 5px;
  margin: 2px;
  text-align: center;
  float: left;
}

.vs-table--tbody {
  z-index: 1 !important;
}

.vdp-datepicker {
  z-index: 2;
}

.vdp-datepicker__calendar {
  right: 0;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .datepicker-main {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    } */
.datepicker-main {
  display: flex;
  align-items: center;
  width: auto;
}
.datewrapper {
  display: flex;
}

.datewrapper label {
  float: right;
  text-align: right;
  line-height: 40px;
  padding-right: 10px;
  font-size: 14px !important;
  font-weight: bold;
}

.sidesheet .vs-sidebar {
  max-width: 450px !important;
  min-width: 450px !important;
  z-index: 99999 !important;
}
.total-hours {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  border-radius: 5px;
  margin-bottom: 10px;
}
.vs-table--search {
  margin: 0 !important;
}
.feather-download,
.feather-printer,
.feather-file-text {
  width: 16px;
  height: 16px;
}
.activity-table {
  max-height: 300px;
  overflow-x: auto;
}
.center-col {
  border-left: 1px solid #e7e7e7 !important;
  border-right: 1px solid #e7e7e7 !important;
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.fc-event,
.fc-event-dot {
  background-color: #3aad68;
}
.fc-event .fcc-content {
  padding-left: 3px;
}
.fc-unthemed td.fc-today {
  background: #3f57fe;
  color: #fff;
}
.fc-unthemed td.fc-past {
  background: #ff9000;
}
.fc-toolbar {
  text-align: right;
}
.hide {
  display: none;
}
.activity-table .header-table {
  justify-content: flex-end !important;
}
.status-table {
  margin-top: 58px;
}
</style>

<style lang="scss">
.sidesheet .vs-sidebar--background {
  z-index: 99999 !important;
}

.sidesheet .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.sidesheet .footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.delete-timesheet {
  margin: 16px 0px;
  padding: 0px 20px;
}

.sidesheet .vs-sidebar--items {
  height: 756px;
  overflow-y: scroll;
}
.vs-table .vs-table--thead .td-check{
  width: 1%;
}
@media all and (max-width:576px){
  .sidesheet .vs-sidebar{
    min-width: unset !important;
  }
}
</style>